var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTheme } from '@material-ui/core';
import { SmartCheckLightConfirmTemplate } from './SmartCheckLightConfirmTemplate';
import { SmartCheckLightCountDownTemplate } from './SmartCheckLightCountDownTemplate';
import { SmartCheckLightBeforeUseTemplate } from './SmartCheckLightBeforeUseTemplate';
import { SmartCheckLightAfterUsedTemplate } from './SmartCheckLightAfterUsedTemplate';
/**
 * SmartCheckLight用テンプレート
 * SmartCheckコンシューマ向け画面では、画面遷移があるため各ステートを管理するコンポーネント
 * ステートによって、画面を切り替える（URLは変更されない）
 */
export var SmartCheckLightTemplate = function (props) {
    var theme = useTheme();
    // 確認画面へ
    if (props.confirm) {
        return (React.createElement("form", { onSubmit: props.handlers.onConfirmSubmit },
            React.createElement(SmartCheckLightConfirmTemplate, __assign({}, props, { theme: theme }))));
    }
    else if (props.available.status === 'USED') {
        if (props.smartCheckCountDown.countDownComplete) {
            // カウントダウン終了後
            return React.createElement(SmartCheckLightAfterUsedTemplate, __assign({}, props, { theme: theme }));
        }
        else {
            // カウントダウン中またはカウントダウン設定無し
            return (React.createElement("form", { onSubmit: props.handlers.onForceSubmit },
                React.createElement(SmartCheckLightCountDownTemplate, __assign({}, props, { theme: theme }))));
        }
    } // 使用前画面
    else {
        return (React.createElement("form", { onSubmit: props.handlers.onUseSubmit },
            React.createElement(SmartCheckLightBeforeUseTemplate, __assign({}, props, { theme: theme }))));
    }
};
//# sourceMappingURL=SmartCheckLightTemplate.js.map